var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inbox--name inline-flex items-center py-0.5 px-0 leading-3 font-medium bg-none text-slate-600 dark:text-slate-500 text-xs my-0 mx-2.5"},[_c('fluent-icon',{staticClass:"mr-0.5 rtl:ml-0.5 rtl:mr-0",attrs:{"icon":_vm.computedInboxClass,"size":"12"}}),_vm._v("\n  "+_vm._s(_vm.inbox.name)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }